import Institution from '@/institutions/models/Institution';
import Role from '@/users/models/Role';
import CourseRole from '@/users/models/CourseRole';
import {CourseSection} from '@/courses/models';
import {Joined} from '@/orm/types/Joined';
import Fields from '@vuex-orm/core/lib/model/contracts/Fields';
import {RawUser} from '@/users/types/RawUser';
import {StembleModel} from '@/common/models/StembleModel';

/**
 * User class
 */
export class User extends StembleModel implements Omit<RawUser, 'courseRoles'> {
  static entity = 'User';

  private _isFaculty: boolean | null = null;

  id!: number;
  firstName!: string;
  lastName!: string;
  createdAt!: string;
  isActive!: boolean;
  hasVerifiedEmail!: boolean;
  email!: string;
  studentId!: string | null;
  avatarUrl!: string;
  institutionId!: number | null;
  institution!: Joined<Institution>;
  roleIds!: number[];
  roles!: Joined<Role[]>;
  courseRoles!: Joined<CourseRole[]>;
  courseSections!: Joined<CourseSection[]>;
  permissions!: string[];

  static fields(): Fields {
    return {
      id: this.number(null),
      firstName: this.string(''),
      lastName: this.string(''),
      createdAt: this.string(''),
      isActive: this.boolean(false),
      hasVerifiedEmail: this.boolean(false),
      email: this.string(''),
      studentId: this.string('').nullable(),
      avatarUrl: this.string(''),
      institutionId: this.number(0).nullable(),
      institution: this.belongsTo(Institution, 'institutionId'),
      roleIds: this.attr([]),
      roles: this.hasManyBy(Role, 'roleIds'),
      courseRoles: this.hasMany(CourseRole, 'userId'),
      courseSections: this.belongsToMany(CourseSection, CourseRole, 'userId', 'courseLikeId'),
      permissions: this.attr([]),
    };
  }
}

export default User;
